module.exports = __webpack_public_path__ + "static/carte_1200px-86d543a3632db0d131f7c2fa487b9731.svg";